import type { Theme } from '@mui/material';

export const styles = {
  closeIcon: (theme: Theme) => ({
    cursor: 'pointer',
    color: theme.colors.primary[500],
    marginBottom: 1.25,
    marginLeft: 'auto',
    alignSelf: 'flex-start',
    svg: {
      color: theme.colors.primary[500],
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  }),
};
